module.exports = __webpack_public_path__ + "img/dots.436dfe24.svg";